import { render, staticRenderFns } from "./SoccerTeamDetail.vue?vue&type=template&id=333a7114&scoped=true&"
import script from "./SoccerTeamDetail.vue?vue&type=script&lang=js&"
export * from "./SoccerTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoccerTeamDetail.vue?vue&type=style&index=0&id=333a7114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a7114",
  null
  
)

export default component.exports